import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

function PasswordForm({ onDone, testid }) {
  const [cur, setCur] = useState("");
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: pw });
      toast.success("Password updated");
      setCur(""); setPw("");
      onDone?.();
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <form onSubmit={submit} className="space-y-4">
      <div className="space-y-1.5">
        <Label>Current (or temporary) password</Label>
        <Input type="password" value={cur} onChange={(e) => setCur(e.target.value)} required data-testid={`${testid}-current`} />
      </div>
      <div className="space-y-1.5">
        <Label>New password (min 8 characters)</Label>
        <Input type="password" minLength={8} value={pw} onChange={(e) => setPw(e.target.value)} required data-testid={`${testid}-new`} />
      </div>
      <Button type="submit" disabled={busy} className="bg-emerald-700 hover:bg-emerald-800 text-white" data-testid={`${testid}-submit`}>
        {busy ? "Saving…" : "Update password"}
      </Button>
    </form>
  );
}

export function ChangePasswordDialog({ open }) {
  const { refresh } = useAuth();
  return (
    <Dialog open={open}>
      <DialogContent className="max-w-md [&>button]:hidden" data-testid="force-password-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Choose your own password</DialogTitle>
          <DialogDescription>You signed in with a temporary password from your welcome pack. Please set a new one to continue.</DialogDescription>
        </DialogHeader>
        <PasswordForm testid="force-password" onDone={refresh} />
      </DialogContent>
    </Dialog>
  );
}

export function AccountCard() {
  const { session, refresh } = useAuth();
  const [name, setName] = useState(session?.user?.name || "");
  const [phone, setPhone] = useState(session?.user?.phone || "");
  const save = async (e) => {
    e.preventDefault();
    try {
      await api.put("/auth/profile", { name, phone });
      await refresh();
      toast.success("Profile saved");
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <form onSubmit={save} className="panel space-y-4" data-testid="profile-form">
        <h3 className="text-xl font-bold">Your profile</h3>
        <div className="space-y-1.5"><Label>Email</Label><Input value={session?.user?.email || ""} disabled /></div>
        <div className="space-y-1.5"><Label>Name</Label><Input value={name} onChange={(e) => setName(e.target.value)} required data-testid="profile-name" /></div>
        <div className="space-y-1.5"><Label>Phone</Label><Input value={phone} onChange={(e) => setPhone(e.target.value)} data-testid="profile-phone" /></div>
        <Button type="submit" className="bg-emerald-700 hover:bg-emerald-800 text-white" data-testid="profile-save">Save profile</Button>
      </form>
      <div className="panel">
        <h3 className="text-xl font-bold mb-4">Change password</h3>
        <PasswordForm testid="change-password" />
      </div>
    </div>
  );
}
